import React, { useEffect,useState } from "react";

export default function useHashTrigger(el) {
const [init,setInit]=useState(false);
const triggerDownload = () => {
    const  hash = window.location.hash;
    if( hash !== "" && document.querySelector(hash) && !init) {    
        setInit(true);
        document.querySelector(hash).focus();
        document.querySelector(hash).click();
        window.location.hash="";
    }
}

  return { triggerDownload };
}
